const FALSE_LIKE = new Set(['0', 'false', 'off', 'no']);

function parseBooleanLike(value, defaultValue = false) {
  if (value === undefined || value === null || value === '') return defaultValue;
  if (typeof value === 'boolean') return value;
  const raw = String(value).trim().toLowerCase();
  return !FALSE_LIKE.has(raw);
}

export const ENTERPRISE_MODE = parseBooleanLike(
  process.env.REACT_APP_ENTERPRISE_MODE,
  false,
);

/** @deprecated Use useProjectMapsEnabled / modules.maps from capabilities instead. */
export const MAPS_UI_ENABLED = parseBooleanLike(
  process.env.REACT_APP_FEATURE_MAPS,
  true,
);

export function isEnterpriseModeEnabledFromConfig(cfg) {
  if (cfg && Object.prototype.hasOwnProperty.call(cfg, 'enterpriseModeEnabled')) {
    return parseBooleanLike(cfg.enterpriseModeEnabled, ENTERPRISE_MODE);
  }
  if (
    cfg &&
    Object.prototype.hasOwnProperty.call(cfg, 'publicSuperadminRegistrationEnabled')
  ) {
    return !parseBooleanLike(cfg.publicSuperadminRegistrationEnabled, true);
  }
  return ENTERPRISE_MODE;
}

export function isMapsUiEnabledFromConfig(cfg) {
  if (cfg && Object.prototype.hasOwnProperty.call(cfg, 'mapsUiEnabled')) {
    return parseBooleanLike(cfg.mapsUiEnabled, true);
  }
  return true;
}
